module.exports = __webpack_public_path__ + "static/media/CarRental.8ff049ba.svg";


//////////////////
// WEBPACK FOOTER
// ./public/img/GuruProfile/CarRental.svg
// module id = 2604
// module chunks = 0